<template>
  <v-container class="limited" grid-list-xl fluid>
    <v-layout row wrap fill-height>
      <v-flex xs12 md4>
        <v-card :color="highContrast ? 'dark' : 'primary'" class="pa-4">
          <h4 class="subheading grey--text mb-3">Beneficiário</h4>
          <p class="body-2 font-weight-regular white--text">
            <b>Número do cartão</b>
            <br />
            {{ dadosBeneficiario.numeroCartao }}
          </p>
          <p class="body-2 font-weight-regular white--text">
            <b>Data de inicio de vigência</b>
            <br />
            {{ dadosBeneficiario.dataInicioVigencia | formatDate }}
          </p>
          <p class="body-2 font-weight-regular white--text">
            <b>Situação atual do beneficiário</b>
            <br />
            {{ dadosBeneficiario.ativo ? "Ativo" : "Inativo" }}
          </p>
          <p class="body-2 font-weight-regular white--text">
            <b>Número do contrato</b>
            <br />
            {{ dadosBeneficiario.contratoId }}
          </p>
        </v-card>
      </v-flex>
      <v-flex xs12 md8>
        <v-card class="pa-4 elevation-5" column height="100%">
          <v-flex xs12>
            <v-layout column>
              <v-layout
                row
                wrap
                align-center
                justify-space-between
                class="mb-3"
              >
                <h4
                  class="subheading font-weight-black primary--text pl-2 mb-0"
                >
                  Dados Pessoais
                </h4>
              </v-layout>
              <v-layout
                v-if="isLoadingDadosPessoais"
                column
                align-center
                justify-center
                class="py-5"
                style="min-height: 240px"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="48"
                  :width="4"
                />
                <p class="body-1 grey--text mt-4 text-xs-center mb-0">
                  Carregando dados pessoais...
                </p>
              </v-layout>
              <v-layout v-else column>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nome"
                      label="Nome Completo"
                      type="text"
                      :value="dadosBeneficiario.nome"
                      disabled
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg4 class="py-0">
                    <v-text-field
                      v-mask="'##/##/####'"
                      name="dataNascimento"
                      label="Data de Nascimento"
                      type="text"
                      disabled
                      :value="dataNascimentoFormatada"
                    />
                  </v-flex>
                  <v-flex xs12 md6 lg4 class="py-0">
                    <v-text-field
                      v-mask="'###.###.###-##'"
                      name="cpf"
                      label="CPF"
                      type="text"
                      disabled
                      :value="dadosBeneficiario.cpf"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row v-if="beneficiarioRg.numero">
                  <v-flex xs12 md6 lg4 class="py-0">
                    <v-text-field
                      name="RG"
                      label="RG"
                      type="text"
                      :value="beneficiarioRg.numero"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md6 lg2 class="py-0">
                    <v-text-field
                      v-mask="'##/##/####'"
                      name="dataExpedicao"
                      label="Data Expedição"
                      type="text"
                      :value="beneficiarioRg.dataExpedicao"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md6 lg2 class="py-0">
                    <v-text-field
                      label="UF Emissor"
                      type="text"
                      disabled
                      :value="beneficiarioRg.ufEmissor"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nomeMae"
                      label="Nome da Mãe"
                      type="text"
                      :value="dadosBeneficiario.nomeMae"
                      disabled
                    />
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nomePai"
                      label="Nome do Pai"
                      type="text"
                      :value="dadosBeneficiario.nomePai"
                      disabled
                    />
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card class="pa-4 elevation-5" column>
          <v-flex xs12>
            <v-layout column>
              <h4 class="subheading font-weight-black primary--textb-3">
                Endereço
              </h4>
              <v-switch
                v-if="listEnderecos && listEnderecos.length > 0 && !isTitular"
                label="Reside com o titular do plano"
                color="orange darken-4"
                disabled
                :value="moraComTitular"
              ></v-switch>
              <v-layout
                v-for="(endereco, index) in listEnderecos"
                :key="`endereco-${index}`"
                column
                class="ma-1 mb-5"
              >
                <v-layout row wrap>
                  <v-flex xs12 md4 lg3 class="py-0">
                    <v-text-field
                      label="Tipo"
                      :value="endereco.tipoEndereco.descricao"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="py-0">
                    <v-text-field
                      v-mask="'#####-###'"
                      label="CEP"
                      name="cep"
                      :value="endereco.cep"
                      disabled
                      :masked="false"
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg4 class="py-0">
                    <v-text-field
                      label="Rua"
                      maxlength="100"
                      name="street"
                      type="text"
                      :value="endereco.logradouro"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg2 class="py-0">
                    <v-text-field
                      label="Número"
                      maxlength="5"
                      name="number"
                      type="text"
                      :value="endereco.numero"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg4 class="py-0">
                    <v-text-field
                      label="Bairro"
                      maxlength="40"
                      name="district"
                      type="text"
                      :value="endereco.bairro"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg4 class="py-0">
                    <v-text-field
                      label="Cidade"
                      maxlength="72"
                      name="city"
                      type="text"
                      :value="endereco.cidade"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg1 class="py-0">
                    <v-text-field
                      label="Estado"
                      name="state"
                      type="text"
                      :value="endereco.uf"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="py-0">
                    <v-text-field
                      label="Complemento"
                      maxlength="30"
                      name="complement"
                      type="text"
                      :value="endereco.complemento"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="py-0">
                    <v-text-field
                      label="Caixa Postal"
                      name="caixaPostal"
                      type="text"
                      :value="endereco.caixaPostal"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg3 class="py-0">
                    <v-text-field
                      label="Ponto de referência"
                      name="pontoReferencia"
                      type="text"
                      :value="endereco.pontoReferencia"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md4 lg6>
                    <h5 class="subheading">
                      Quando necessário, é neste endereço que gostaria de
                      receber:
                    </h5>
                    <v-layout row wrap>
                      <div
                        v-for="(finalidade,
                        indexFinalidade) in endereco.finalidades"
                        :key="indexFinalidade"
                        class="mr-3"
                      >
                        <v-checkbox
                          :key="indexFinalidade"
                          :value="
                            endereco.finalidades[indexFinalidade].selecionado
                          "
                          :label="finalidade.descricao"
                          disabled
                          color="primary"
                          hide-details
                        />
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider v-if="index + 1 < listEnderecos.length" />
              </v-layout>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card class="pa-4 elevation-5" column v-if="isTitular">
          <v-flex xs12>
            <v-layout column>
              <h4 class="subheading font-weight-black primary--text">
                Contato
              </h4>
              <v-layout row wrap>
                <v-flex xs12 md6 lg3 class="py-0">
                  <v-text-field
                    v-mask="'(##)####-####'"
                    name="phone"
                    label="Telefone"
                    type="text"
                    disabled
                    :value="contatoTelefone.contato"
                  />
                </v-flex>
                <v-flex xs12 md6 lg3 class="py-0">
                  <v-text-field
                    v-mask="'(##)#####-####'"
                    name="cellPhone"
                    label="Celular"
                    type="text"
                    disabled
                    :value="contatoCelular.contato"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6 lg3 class="py-0">
                  <v-text-field
                    name="email"
                    label="E-mail"
                    type="text"
                    disabled
                    :value="contatoEmail.contato"
                  />
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { mask } from "vue-the-mask";
import {
  getDadosPessoais,
  getPessoaContatos,
  getEnderecoBeneficiario
} from "@/services/movimentos";
import { formatDate } from "@/utils/date";

const ENDERECO_RESIDENCIA_ID = "00000000-0000-0000-0000-000000000001";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "BeneficiaryReadOnlyRegistration",
  directives: { mask },
  data() {
    return {
      pessoaContatos: null,
      contatoCelular: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000001",
          descricao: "Celular"
        },
        contato: null
      },
      contatoTelefone: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000002",
          descricao: "Telefone Fixo"
        },
        contato: null
      },
      contatoEmail: {
        id: null,
        tipoContato: {
          id: "00000000-0000-0000-0000-000000000003",
          descricao: "E-mail"
        },
        contato: null
      },
      listEnderecos: [],
      finalidades: []
    };
  },
  computed: {
    ...beneficiarioStore.mapState([
      "dadosBeneficiario",
      "isLoadingDadosPessoais"
    ]),
    ...portalStore.mapState(["highContrast"]),
    isTitular() {
      return this.dadosBeneficiario.titular;
    },
    pessoaId() {
      return this.dadosBeneficiario?.pessoaId;
    },
    beneficiarioRg() {
      return {
        numero: this.dadosBeneficiario.rgNumero || "",
        dataExpedicao: this.dadosBeneficiario.rgDataExpedicao || "",
        ufEmissor: this.dadosBeneficiario.rgUfEmissor || ""
      };
    },
    dataNascimentoFormatada() {
      return formatDate(this.dadosBeneficiario?.dataNascimento) || "";
    }
  },
  async created() {
    this.setIsLoadingDadosPessoais(true);

    await Promise.all([
      this.loadBeneficiaryData(),
      this.loadPessoaContatos(),
      this.loadBeneficiarioEnderecos()
    ]);
  },
  methods: {
    ...beneficiarioStore.mapMutations([
      "setTrocarBeneficiario",
      "mergeDadosBeneficiarioPessoais",
      "setIsLoadingDadosPessoais"
    ]),
    ...portalStore.mapMutations(["setErrorToast", "setToast"]),
    async loadBeneficiaryData() {
      await getDadosPessoais(this.pessoaId)
        .then(({ data, errors }) => {
          const primeiroDadoPessoal = data?.dadosPessoais?.[0];
          if (primeiroDadoPessoal) {
            this.mergeDadosBeneficiarioPessoais(primeiroDadoPessoal);
          }

          if (errors && errors[0]?.message) {
            const errorMessage = errors[0]?.message?.split(": ")[1];

            this.setErrorToast(errorMessage);
          }
        })
        .finally(() => {
          this.setIsLoadingDadosPessoais(false);
        });
    },
    async loadPessoaContatos() {
      await getPessoaContatos(this.pessoaId).then(({ data, errors }) => {
        if (errors && errors.length) {
          const errorMessage = errors[0].message.split(": ")[1];

          this.setErrorToast(errorMessage);
        } else {
          data?.pessoaContatos?.forEach(contato => {
            const chaves = contato.id.split(";");
            const tipo = chaves[2];

            switch (tipo) {
              case "T":
                this.contatoTelefone.contato = contato.contato;
                break;
              case "C":
                this.contatoCelular.contato = contato.contato;
                break;
              case "E":
                this.contatoEmail.contato = contato.contato;
                break;
            }
          });
        }
      });
    },
    async loadBeneficiarioEnderecos() {
      const codigoBeneficiario = this.dadosBeneficiario?.id;

      await getEnderecoBeneficiario(this.pessoaId, codigoBeneficiario).then(
        async response => {
          const errorMessage = response.data?.message;

          if (errorMessage) {
            this.setErrorToast(errorMessage);
          }

          if (response.data.length > 0) {
            this.listEnderecos = response.data;
          }
        }
      );

      if (!this.listEnderecos.length) {
        this.listEnderecos = await this.getEnderecoTitular();
      }

      this.listEnderecos = JSON.parse(
        JSON.stringify(this.listEnderecos ?? [])
      ).map(endereco => {
        endereco.finalidades = JSON.parse(JSON.stringify(this.finalidades)).map(
          finalidade => {
            finalidade.idd = Math.random();
            finalidade.selecionado = endereco.enderecoFinalidades.find(
              enderecoFinalidade => enderecoFinalidade.id === finalidade.id
            )
              ? true
              : null;

            return finalidade;
          }
        );

        return endereco;
      });

      if (!this.isTitular && this.listEnderecos.length > 1) {
        this.listEnderecos = this.listEnderecos.filter(
          endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
        );
      }
    },
    async getEnderecoTitular() {
      if (!this.isTitular) {
        await getEnderecoBeneficiario(
          null,
          this.dadosBeneficiario?.pessoaTitularId
        ).then(({ data, errors }) => {
          if (errors && errors.length) {
            const errorMessage = errors[0].message.split(": ")[1];

            this.setErrorToast(errorMessage);
          } else {
            return data.pessoaEnderecos.filter(
              endereco => endereco.tipoEndereco.id === ENDERECO_RESIDENCIA_ID
            );
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
@media only screen and (min-width: 1904px) {
  .limited {
    max-width: 1185px;
    margin-left: 0;
  }
}
</style>
